import React, { useEffect, useRef, useState } from 'react';

import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react-lite';

import { ExportToCalendar } from 'screens/booker/components/ExportToCalendar';
import { Button } from 'components/Button';
import { css } from '@emotion/react';
import { Controller, useForm } from 'react-hook-form';
import { Input } from 'components/Input';
import { InputStyle } from 'styles/InputStyle';
import { theme } from 'styles/theme';
import { Dropdown } from 'components/Dropdown';
import { Select } from 'components/Select';
import { PhoneInput } from 'components/PhoneInput';

export const ExampleScreen = () => {
	return <TestScreen />;
};

export const TestScreen = observer(() => {
	const { calendarApi } = useStore();

	return (
		<div>
			<TestingPhoneInputForm />

			<ConnectToGoogle />
			<button onClick={calendarApi.handleClickAuth}>Sign In</button>
			<button onClick={calendarApi.getCals}>Calendar List</button>

			<hr />

			<ExportToCalendar />
		</div>
	);
});

export const TestingPhoneInputForm = () => {
	const defaultValues = { name: 'Pavel', phone: '+421 774300257' };

	const { control, handleSubmit, register, watch } = useForm({ defaultValues: defaultValues });

	const onSubmit = () => {
		alert('test');
	};

	const phoneValueWatch = watch('phone');

	const isOpen = false;

	return (
		<div>
			<h1>Testing Phone Input Form</h1>

			{phoneValueWatch}

			<form
				onSubmit={handleSubmit(onSubmit)}
				css={css`
					width: 320px;
				`}
			>
				<input {...register('name', { required: 'yesah asdga' })} />

				<Controller
					control={control}
					name="phone"
					render={({ field }) => {
						return <PhoneInput {...field} placeholder="Zadejte cislo..." />;
					}}
				/>
			</form>

			<br />
			<br />
			<hr />
			<br />
			<br />
		</div>
	);
};

{
	/* <Controller
	name={FORM_EVENT.ARTIST}
	control={control}
	rules={{ required: 'Vyberte interpreta.' }}
	render={({ field }) => {
		return (
			<Select
				{...field}
				options={artistsOptions}
				placeholder="Vyberte interpreta..."
				error={errors[FORM_EVENT.ARTIST]}
			/>
		);
	}}
/>; */
}

export const ConnectToGoogle = observer(() => {
	const { calendarApi } = useStore();
	return (
		<div
			css={css`
				padding: 20px 0 24px;
				margin: 12px 24px;

				border: 1px solid #f0f0ff;
				border-left: 0;
				border-right: 0;
			`}
		>
			<div
				css={css`
					font-size: 13px;
					line-height: 20px;

					margin-bottom: 12px;
					font-weight: bold;
				`}
			>
				Google Kalendář
			</div>

			<Button block outline small onClick={calendarApi.handleClickAuth}>
				Přihlásit se
			</Button>
		</div>
	);
});
